module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-09-74a3b0b1e96ef83b0b179b013e7b216f.jpg";